module.exports = __webpack_public_path__ + "static/media/Dow Corning.fd567743.webp";